export default __webpack_public_path__ + "static/media/invite_fb.2fcd3f47.svg";